export const ListQueryKey = 'activityRecommendRecords';
export const DetailQueryKey = 'activityRecommendRecord';
export const Urls = {
  selectUrl: '/LtZy/list',
  updateUrl: '/LtZy/update',
  deleteUrl: '/LtZy/delete',
  createUrl: '/LtZy/create',
  detailUrl: '/LtZy/info'
};